module.exports = __webpack_public_path__ + "static/media/adyen_icon.ea9fdbf1.svg";